import { render, staticRenderFns } from "./CommonsSettings.vue?vue&type=template&id=02e7a268&scoped=true"
import script from "./CommonsSettings.vue?vue&type=script&lang=js"
export * from "./CommonsSettings.vue?vue&type=script&lang=js"
import style0 from "./CommonsSettings.vue?vue&type=style&index=0&id=02e7a268&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e7a268",
  null
  
)

export default component.exports